import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const SyntheseAnnuelle = ({ listData }) => {
  const verifierNull = (variable) => {
    if (variable !== null) {
      return true;
    }
  };
  const style = { fontFamily: "sans-serif", textAlign: "right" };

  return (
    <>
      {listData.allowed ? (
        <Col>
         <CardTitle style={{ color: "#3498db" }} className="mb-2">
                {listData.title}
              </CardTitle>
          <Card className="mini-stats-wid">
            <CardBody>
             
              <div className="table-responsive">
                <table className="table table">
                  <thead className="nowrap-header">
                    <tr>
                      {listData?.header?.map((item, index) => (
                        <>
                          {item === "En euros" ? (
                            <th key={index} className="text-nowrap">
                              {item}
                            </th>
                          ) : (
                            <th
                              style={{ textAlign: "right" }}
                              key={index}
                              className="text-nowrap"
                            >
                              {item}
                            </th>
                          )}
                        </>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {listData.data.length > 0 ? (
                      listData.data.map((item, id) => (
                        <tr key={id}>
                          <>
                            {Object.entries(item).map(([key, value]) =>
                              key === "title" ? (
                                <td>{value}</td>
                              ) : key === "text" ? (
                                <td style={{ fontFamily: "sans-serif" }}>
                                  {value}
                                </td>
                              ) : (
                                <td style={style}>
                                  {verifierNull(value)
                                    ? value.toLocaleString("fr-FR", {
                                        style: "currency",
                                        currency: "EUR", minimumFractionDigits: 0,
                                      })
                                    : ""}
                                </td>
                              )
                            )}
                          </>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={listData.header.length}>
                          Aucune donnée disponible
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default SyntheseAnnuelle;
